import React from "react";

  export default class HealthCheck extends React.Component<{}> {
    render() {
      return(<div>Health Check Passed!!!</div>);
    }
}
